import camelcase from 'camelcase';
import produce from 'immer';

import roles from '@constants/roles';
import {
  PermissionsSections,
  RoleCodes,
} from '@models/User/permissions/permissionsRoleModel/helpers/types';

import { buildFilingSettingsSections } from './helpers';
import type { PermissionsSchema, PermissionsMatrix, RolesList } from './types';

/**
 * Gets permissions matrix
 */
export const permissionsRoleModel = (schema: PermissionsSchema): PermissionsMatrix => {
  const list: RolesList = Object.entries(schema) as RolesList;

  return list.reduce(
    (accumulator: PermissionsMatrix, currentValue) =>
      produce(accumulator, draft => {
        const key = camelcase(currentValue[0] ?? '') as RoleCodes;

        draft[key] = {
          id: key,
          name: roles[key],
          ...buildFilingSettingsSections(currentValue[1]),
        } as PermissionsSections;
      }),
    {} as PermissionsMatrix
  );
};
